import { getFormOptions } from "@/api/formoptions";

export const action = (parentVue) => {
    return {
        render: (h, params) => {
            const vm = parentVue.$refs.rcmTable;

            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });

            let dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                    disabled: vm.isDeleteBtnDisabled,
                },
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                    },
                    on: {
                        "on-click": (value) => {
                            let currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map((item) => {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );

            const actionDivArray = [editBtn, moreBtn];
            return h("div", actionDivArray);
        },
    };
};

export const settingZoneExplain = () => {
    return {
        description:
            "<p>Implement custom logic atop automatically applied WAF rules during intelligent protection.</p>",
    };
};

export const groupName = (parentVue) => {
    return {
        remoteOptions: async (queryValue, queryParams) => {
            // 取得後台回應的選項
            queryValue = queryValue || "*";
            queryParams.groupNames = `*${queryValue}*`;
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`groupnames?${queryString}`);
            // 取得已經有 intelligentProtectionSettings 的 groupName
            const vm = parentVue.$refs.rcmTable;
            const alreadyHasConfig = new Set(vm.getEsResult.mapData.map((e) => e.groupName));
            // 過濾掉已存在的 groupName
            return result.data.options.filter((option) => !alreadyHasConfig.has(option));
        },
    };
};

const settingTypeMap = new Map([
    ["DDoSAnalyze", "ddosAnalyze"],
    ["BehaviorAnalyze", "behaviorAnalyze"],
]);
export const settingType = (parentVue) => {
    return {
        defaultVal: settingTypeMap.get(parentVue.searchView) || "",
    };
};



// WEBPACK FOOTER //
// ./src/view/IntelligentProtectionSettings/fields.js